import QuickLinksBlock from "./QuickLinksBlock";

export default QuickLinksBlock;
